<template>
  <div>
    <TireGuide v-if="esNeumaticos" />
    <BatteryGuide v-if="esBaterias" />
  </div>
</template>

<script setup>

import TireGuide from '~/components/Home/Tire/TireGuide.vue'
import BatteryGuide from '~/components/Home/Battery/BatteryGuide.vue'

import { NEGOCIOS } from "~/constants/negocios"

const modo_sistema = useState('modo_sistema');

// Computed properties mejoradas pero manteniendo tu lógica
const esNeumaticos = computed(() => modo_sistema.value === NEGOCIOS.NEUMATICOS)
const esBaterias = computed(() => modo_sistema.value === NEGOCIOS.BATERIAS)

</script>
